import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const getTemplatedFolders = async (caseTypeId, parentFolderId) => {
  const response = await apollo.query(
    {
      query: gql(`
        query templatedFolders($caseTypeId: Int!, $parentFolderId: Int) {
          templatedFolders(caseTypeId: $caseTypeId, parentFolderId: $parentFolderId) {
            id
            parentFolderId
            caseTypeId
            folderName
            folderPath
            createdAt
            updatedAt
          }
        }`),
      variables: { caseTypeId, parentFolderId }
    }
  )
  return response.data.templatedFolders
}

export const createTemplatedFolder = async (folderName, caseTypeId, parentFolderId = null) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createTemplatedFolder($folderName: String!, $caseTypeId: Int!, $parentFolderId: Int) {
          createTemplatedFolder(folderName: $folderName, caseTypeId: $caseTypeId, parentFolderId: $parentFolderId) {
            folder {
              id
              parentFolderId
              caseTypeId
              folderName
              folderPath
              createdAt
              updatedAt
            }
            error
            message
            lowLevelErrorMessage
          }
        }`),
      variables: { folderName, caseTypeId, parentFolderId }
    }
  )
  return response.data.createTemplatedFolder
}

export const deleteTemplatedFolder = async (folderId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteTemplatedFolder($folderId: Int!) {
          deleteTemplatedFolder(folderId: $folderId) {
            folder {
              id
              parentFolderId
              caseTypeId
              folderName
              createdAt
              updatedAt
            }
            error
            message
            lowLevelErrorMessage
          }
        }`),
      variables: { folderId }
    }
  )
  return response.data.deleteTemplatedFolder
}

export const updateTemplatedFolder = async (folderId, folderName) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation updateTemplatedFolder($folderId: Int!, $folderName: String!) {
          updateTemplatedFolder(folderId: $folderId, folderName: $folderName) {
            folder {
              id
              parentFolderId
              caseTypeId
              folderName
              folderPath
              createdAt
              updatedAt
            }
            error
            message
            lowLevelErrorMessage
          }
        }`),
      variables: { folderId, folderName }
    }
  )
  return response.data.updateTemplatedFolder
}

export const getCaseFolders = async (caseId, parentFolderId) => {
  const response = await apollo.query(
    {
      query: gql(`
        query caseFolders($caseId: Int!, $parentFolderId: Int) {
          caseFolders(parentFolderId: $parentFolderId, caseId: $caseId) {
            id
            parentFolderId
            caseId
            folderName
            folderPath
            createdAt
            updatedAt
          }
        }`),
      variables: { caseId, parentFolderId }
    }
  )
  return response.data.caseFolders
}

export const getBreadcrumbFolders = async (caseId, path) => {
  const response = await apollo.query(
    {
      query: gql(`
        query breadcrumbFolders($caseId: Int!, $path: String!) {
          breadcrumbFolders(caseId: $caseId, path: $path) {
            id
            parentFolderId
            caseId
            folderName
            folderPath
            createdAt
            updatedAt
          }
        }`),
      variables: { caseId, path }
    }
  )
  return response.data.breadcrumbFolders
}
